import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {SignUpComponent} from "./component/sign-up/sign-up.component";
import {InputMaskModule} from "primeng/inputmask";
import {RegistrationPage} from "./page/registration/registration.page";
import {
  RegistrationAccountSetupComponent
} from "./component/registration-account-setup/registration-account-setup.component";
import {MessageModule} from "primeng/message";
import {
  RegistrationPersonalInfoComponent
} from "./component/registration-personal-info/registration-personal-info.component";
import {CrossModule} from "../cross/cross.module";
import {DividerModule} from "primeng/divider";
import {PasswordModule} from "primeng/password";
import {FileUploadModule} from "primeng/fileupload";
import {DropdownModule} from "primeng/dropdown";
import {CalendarModule} from "primeng/calendar";
import {SelectButtonModule} from "primeng/selectbutton";
import {RegistrationBaseComponent} from "./component/registration-base-component/registration-base-component";
import {RegistrationAddressComponent} from "./component/registration-address/registration-address.component";
import {
  RegistrationNotificationsComponent
} from "./component/registration-notifications/registration-notifications.component";
import {ToggleButtonModule} from "primeng/togglebutton";
import {
  RegistrationSignaturesComponent
} from "./component/registration-signatures/registration-signatures.component";
import {TooltipModule} from "primeng/tooltip";
import {RegistrationOtpComponent} from "./component/registration-otp/registration-otp.component";
import {RegistrationSuccessComponent} from "./component/registration-success/registration-success.component";
import {KeyFilterModule} from "primeng/keyfilter";
import {ImageCropperModule} from "ngx-image-cropper";
import {PostActivitiesComponent} from "./component/post-activities-component/post-activities.component";
import {CardModule} from "primeng/card";


@NgModule({
  declarations: [
    RegistrationOtpComponent,
    SignUpComponent,
    RegistrationBaseComponent,
    RegistrationAccountSetupComponent,
    RegistrationPersonalInfoComponent,
    RegistrationPage,
    RegistrationAddressComponent,
    RegistrationNotificationsComponent,
    RegistrationSignaturesComponent,
    RegistrationSuccessComponent,
    PostActivitiesComponent,
  ],
  exports:[
    RegistrationOtpComponent,
    SignUpComponent,
    RegistrationBaseComponent,
    RegistrationAccountSetupComponent,
    RegistrationPersonalInfoComponent,
    RegistrationPage,
    RegistrationAddressComponent,
    RegistrationNotificationsComponent,
    RegistrationSignaturesComponent,
    RegistrationSuccessComponent,
    PostActivitiesComponent,
  ],
  imports: [
    CoreModule,
    CrossModule,
    MessageModule,
    InputMaskModule,
    DividerModule,
    FileUploadModule,
    DropdownModule,
    CalendarModule,
    SelectButtonModule,
    ToggleButtonModule,
    PasswordModule,
    KeyFilterModule,
    ImageCropperModule,
    CardModule,
  ]

})
export class RgModule { }

